"use client";

import { c as _c } from "react/compiler-runtime";
import { PauseCircle, LogOut } from "lucide-react";
import Image from "next/image";
import { useClerk } from "@clerk/nextjs";
import { SuperAdminBillingGateExemptLockoutControl } from "./super-admin-billing-gate-exempt-control";
interface TrialEndedPendingPageProps {
  billingAdminName: string | null;
}
export function TrialEndedPendingPage(t0) {
  const $ = _c(18);
  const {
    billingAdminName
  } = t0;
  const clerk = useClerk();
  let t1;
  if ($[0] !== clerk) {
    t1 = () => clerk.signOut({
      redirectUrl: "/sign-in"
    });
    $[0] = clerk;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LogOut className="h-3.5 w-3.5" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <button onClick={t1} className="absolute right-4 top-4 flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs text-slate-400 hover:bg-slate-100 hover:text-slate-600 transition-colors">{t2}Sign out</button>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex justify-center mb-10"><Image src="/covalogo.png" alt="Cova Logo" width={120} height={40} priority={true} /></div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex justify-center mb-6"><PauseCircle className="h-16 w-16 text-slate-400" strokeWidth={1.5} /></div>;
    t6 = <h1 className="text-2xl font-semibold text-slate-900 text-center mb-3">Your organisation's trial has ended</h1>;
    t7 = <p className="text-sm text-slate-600 text-center leading-relaxed max-w-sm mx-auto">Your admin is setting up billing — you'll have access again shortly.</p>;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
  }
  let t8;
  if ($[9] !== billingAdminName) {
    t8 = billingAdminName && <p className="text-sm text-slate-600 text-center mt-2">Contact {billingAdminName} for details.</p>;
    $[9] = billingAdminName;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t10;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="mt-10 text-center"><a href="mailto:support@cova.ai" className="text-sm text-slate-500 hover:text-slate-700 underline underline-offset-2">Contact Support</a><p className="text-xs text-slate-400 mt-2">Or contact support at support@cova.ai</p></div>;
    t10 = <SuperAdminBillingGateExemptLockoutControl />;
    $[11] = t10;
    $[12] = t9;
  } else {
    t10 = $[11];
    t9 = $[12];
  }
  let t11;
  if ($[13] !== t8) {
    t11 = <div className="w-full max-w-md">{t4}{t5}{t6}{t7}{t8}{t9}{t10}</div>;
    $[13] = t8;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11 || $[16] !== t3) {
    t12 = <div className="relative min-h-screen bg-white flex flex-col items-center justify-center px-4 py-12">{t3}{t11}</div>;
    $[15] = t11;
    $[16] = t3;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  return t12;
}